module.exports = __webpack_public_path__ + "media/images/test-82cf94b4aa4e7f474e813019f9d578b1.jpg";